export class ChangeOrderChoiceAttribute {
    public id: number;
    public jobChangeOrderChoiceId: number;
    public attributeGroupCommunityId: number;
    public attributeCommunityId: number;
    public attributeName: string;
    public attributeGroupLabel: string;
    public manufacturer: string;
    public sku: string;
    public action: string;
    public createdBy: string;
    public createdUtcDate: Date;
    public lastModifiedBy: string;
    public lastModifiedUtcDate: Date;
    public attributeGroupLabelDisplay: string;
    public isAttributeReassigned: boolean;
}
